<template>
  <div class="login-container">
    <el-tabs v-model="loginType" stretch>
      <el-tab-pane label="密码登录" name="password" />
      <el-tab-pane label="快捷登录" name="phone-code" />
    </el-tabs>
    <transition :name="transformName" mode="out-in">
      <component :is="loginType" />
    </transition>
    <div class="route-button">
      <el-link type="primary" :underline="false" @click="routeLink('forget')">忘记密码</el-link>
      <el-link type="primary" :underline="false" @click="$refs.download.openDialog()">下载APP(Android)</el-link>
      <el-link type="primary" :underline="false" @click="routeLink('register')">注册账户</el-link>
    </div>
    <download-app ref="download" />
  </div>
</template>

<script>
import Password from "./components/Password";
import PhoneCode from "./components/PhoneCode";
import DownloadApp from "./components/DownloadApp";

export default {
  components: {
    Password,
    PhoneCode,
    DownloadApp
  },

  data() {
    return {
      loginType: "password"
    };
  },

  computed: {
    transformName() {
      const suffix = this.loginType === "password" ? "" : "-reverse";
      return `fade-transform${suffix}`;
    }
  },

  methods: {
    routeLink(link) {
      this.$router.push({
        path: link
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  padding: 0 20px;

  .el-tabs {
    font-size: 16px;
    margin: 10px 0 20px 0;

    ::v-deep .el-tabs__nav {
      padding-bottom: 10px;
    }

    ::v-deep .el-tabs__item {
      font-size: 16px;
    }
  }

  .route-button {
    display: flex;
    justify-content: space-between;
  }
}
</style>

<style lang="scss">
$cursor: #515a6e;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    input {
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }
}
</style>